import React from "react";
import "./Products.css";
import SocialIcons from "../SocialIcons";
// import { useNavigate } from "react-router-dom";


function Products() {
  //  const navigate = useNavigate();
  const products = [
    {
      name: "Mono PERC Solar Panel",
      desc: "High efficiency solar panel for maximum output",
      img: "https://images.unsplash.com/photo-1509395176047-4a66953fd231"
    },
    {
      name: "Solar Inverter",
      desc: "Convert DC to AC with high efficiency",
      img: "https://images.unsplash.com/photo-1581092919534-1c5c7b65b3f2"
    },
    {
      name: "Lithium Battery",
      desc: "Long life battery for solar storage",
      img: "https://images.unsplash.com/photo-1603732551681-42c3c1a36c6d"
    },
    {
      name: "Mounting Structure",
      desc: "Strong structure for panel installation",
      img: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e"
    }
  ];

  return (
    <div className="products">

      {/* 🔥 HERO SECTION */}
      <div className="hero">
        <h1>Our Solar Products</h1>
        <p>High Quality • Reliable • Affordable</p>
      </div>

      {/* ⚡ CATEGORY SECTION */}
      <div className="categories">
        <h2>Product Categories</h2>
        <div className="category-grid">
          <div>Solar Panels</div>
          <div>Inverters</div>
          <div>Batteries</div>
          <div>Accessories</div>
        </div>
      </div>

      {/* 🔍 PRODUCTS */}
      <div className="product-section">
        <h2>Featured Products</h2>

        <div className="product-grid">
          {products.map((item, index) => (
            <div className="card" key={index}>
              <img src={item.img} alt={item.name} />
              <h3>{item.name}</h3>
              <p>{item.desc}</p>
              <button>Get Quote</button>
            </div>
          ))}
        </div>
      </div>

      {/* 📊 COMPARISON */}
      <div className="comparison">
        <h2>System Comparison</h2>
        <table>
          <thead>
            <tr>
              <th>Feature</th>
              <th>On-Grid</th>
              <th>Off-Grid</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Battery</td>
              <td>No</td>
              <td>Yes</td>
            </tr>
            <tr>
              <td>Cost</td>
              <td>Low</td>
              <td>High</td>
            </tr>
            <tr>
              <td>Backup</td>
              <td>No</td>
              <td>Yes</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 💰 PACKAGES */}
      <div className="packages">
        <h2>Solar Packages</h2>
        <div className="package-grid">
          <div className="package">
            <h3>2kW System</h3>
            <p>Best for small homes</p>
            <button>Enquire</button>
          </div>

          <div className="package">
            <h3>3kW System</h3>
            <p>Medium usage homes</p>
            <button>Enquire</button>
          </div>

          <div className="package">
            <h3>5kW System</h3>
            <p>High usage homes</p>
            <button>Enquire</button>
          </div>
        </div>
      </div>

      {/* ⭐ WHY US */}
      <div className="why">
        <h2>Why Choose Our Products</h2>
        <ul>
          <li>✔ High Efficiency</li>
          <li>✔ Long Warranty</li>
          <li>✔ Govt Approved</li>
          <li>✔ Premium Quality</li>
        </ul>
      </div>

      {/* 📞 CTA */}
      <div className="cta">
        <h2>Get Free Consultation</h2>
        <button>Call Now</button>
        <button>WhatsApp</button>
      </div>
<SocialIcons />
    </div>
  );
}

export default Products;